import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const links = [
  { href: '#top', label: 'Home' },
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Contact' },
  { href: '#publications', label: 'Publications' },
]

export default function Navigation() {
  const [open, setOpen] = useState(false)
  const [active, setActive] = useState('top')

  useEffect(() => {
    const sections = links
      .map(({ href }) => document.querySelector(href))
      .filter(Boolean)

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]
        if (visible) setActive(visible.target.id)
      },
      { rootMargin: '-25% 0px -60% 0px', threshold: [0.05, 0.25, 0.5] }
    )

    sections.forEach((section) => observer.observe(section))
    return () => observer.disconnect()
  }, [])

  const navigate = () => setOpen(false)

  return (
    <Header>
      <Nav className="container" aria-label="Primary navigation">
        <Brand href="#top" onClick={navigate}>Sirion Vittayakorn</Brand>
        <MenuButton
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={open}
          aria-controls="primary-menu"
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </MenuButton>
        <Menu id="primary-menu" $open={open}>
          {links.map(({ href, label }) => (
            <NavLink
              key={href}
              href={href}
              $active={active === href.slice(1)}
              onClick={navigate}
            >
              {label}
            </NavLink>
          ))}
        </Menu>
      </Nav>
    </Header>
  )
}

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(250, 249, 249, 0.9);
  border-bottom: 1px solid rgba(85, 91, 110, 0.08);
  backdrop-filter: blur(14px);
`

const Nav = styled.nav`
  position: relative;
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
`

const Brand = styled.a`
  color: var(--assent-color);
  font-family: 'Concert One', cursive;
  font-size: 1.35rem;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    color: var(--assent-color);
  }
`

const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 767px) {
    position: absolute;
    top: calc(100% + 1px);
    right: 12px;
    left: 12px;
    display: ${({ $open }) => ($open ? 'grid' : 'none')};
    gap: 4px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(85, 91, 110, 0.1);
    border-radius: 14px;
    box-shadow: 0 16px 32px rgba(38, 46, 55, 0.14);
  }
`

const NavLink = styled.a`
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  padding: 8px 13px;
  color: ${({ $active }) => ($active ? 'var(--assent-color)' : 'var(--text-color)')};
  border-radius: 999px;
  font-weight: 600;
  text-decoration: none;
  background: ${({ $active }) => ($active ? 'rgba(var(--assent-color-rgb), 0.09)' : 'transparent')};

  &:hover,
  &:focus-visible {
    color: var(--assent-color);
    background: rgba(var(--assent-color-rgb), 0.08);
  }

  @media (max-width: 767px) {
    width: 100%;
    border-radius: 10px;
  }
`

const MenuButton = styled.button`
  display: none;
  width: 44px;
  height: 44px;
  padding: 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;

  span {
    display: block;
    width: 22px;
    height: 2px;
    margin: 4px auto;
    background: var(--text-color);
    border-radius: 2px;
  }

  &:hover,
  &:focus-visible {
    background: rgba(var(--assent-color-rgb), 0.08);
  }

  @media (max-width: 767px) {
    display: block;
  }
`
